import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { objectBy } from '@debbie/common/dist/util/index.js';
import { useCaseGroups } from '@debbie/cortex/dist/case-groups/index.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import Checkbox from '../../Checkbox.js';
import DateInput from '../../DateInput.js';
import Textarea from '../../Textarea.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
let tid = null;
const CasesGroup = (props) => {
    const { caseFilter } = props;
    const endReasons = useEndReasons();
    const endReasonLookup = h.hasData(endReasons)
        ? objectBy(endReasons.data, (er) => er.id)
        : {};
    const lang = useSelector((s) => s.lang);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const [caseSeqIdValue, setCaseSeqIdValue] = useState('');
    return (React.createElement(FilterGroup, { name: lang.caseFilter.casesGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.caseStatuses && caseFilter.caseStatuses.length), header: lang.caseFilter.caseStatus, onDeactivate: () => caseFilterStore.clearFilter('caseStatuses') },
            React.createElement(Select, { value: (caseFilter.caseStatuses || []).map((status) => ({
                    label: lang.cases[status],
                    value: status,
                })), isMulti: true, placeholder: lang.caseFilter.selectCaseStatus, classNamePrefix: "select", options: Object.values(CaseStatus).map((status) => ({
                    label: lang.cases[status],
                    value: status,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        caseStatuses: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseEndReasonIds && caseFilter.caseEndReasonIds.length), header: lang.caseFilter.endReasons, onDeactivate: () => caseFilterStore.clearFilter('caseEndReasonIds') },
            React.createElement(Select, { value: (caseFilter.caseEndReasonIds || []).map((endReasonId) => ({
                    label: lang.endReason[endReasonLookup[endReasonId].handle] ?? endReasonLookup[endReasonId].label,
                    value: endReasonId,
                })), isMulti: true, placeholder: lang.caseFilter.selectEndReasons, classNamePrefix: "select", options: (h.hasData(endReasons) ? endReasons.data : []).map((reason) => {
                    return {
                        label: lang.endReason[reason.handle] ??
                            reason.label,
                        value: reason.id,
                    };
                }), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        caseEndReasonIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseGroups && caseFilter.caseGroups.length), header: lang.caseFilter.caseGroup, onDeactivate: () => caseFilterStore.clearFilter('caseGroups') },
            React.createElement(Select, { value: (caseFilter.caseGroups || []).map((caseGroupId) => {
                    const caseGroup = caseGroups && caseGroups.find((cG) => cG.id === caseGroupId);
                    return {
                        label: (caseGroup && caseGroup.label) || caseGroupId,
                        value: caseGroupId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectCaseGroup, classNamePrefix: "select", options: (caseGroups || []).map((caseGroup) => ({
                    label: caseGroup.label,
                    value: caseGroup.id,
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        caseGroups: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseCreationDate && caseFilter.caseCreationDate.from), header: lang.caseFilter.caseCreatedAfter, onDeactivate: () => caseFilterStore.clearFilter('caseCreationDate', true, 'from') },
            React.createElement(DateInput, { allowNull: true, style: { marginBottom: '0' }, value: (caseFilter.caseCreationDate &&
                    caseFilter.caseCreationDate.from &&
                    moment(caseFilter.caseCreationDate.from)) ||
                    undefined, onChange: (e) => caseFilterStore.updateFilter({
                    caseCreationDate: {
                        ...caseFilter.caseCreationDate,
                        from: e.format(),
                    },
                }), placeholder: lang.caseFilter.caseCreatedAfterPlaceholder })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseCreationDate && caseFilter.caseCreationDate.to), header: lang.caseFilter.caseCreatedBefore, onDeactivate: () => caseFilterStore.clearFilter('caseCreationDate', true, 'to') },
            React.createElement(DateInput, { allowNull: true, style: { marginBottom: '0' }, value: (caseFilter.caseCreationDate &&
                    caseFilter.caseCreationDate.to &&
                    moment(caseFilter.caseCreationDate.to)) ||
                    undefined, onChange: (e) => caseFilterStore.updateFilter({
                    caseCreationDate: {
                        ...caseFilter.caseCreationDate,
                        to: e.format(),
                    },
                }), placeholder: lang.caseFilter.caseCreatedBeforePlaceholder })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseEndedDate && caseFilter.caseEndedDate.from), header: lang.caseFilter.caseEndedAfter, onDeactivate: () => caseFilterStore.clearFilter('caseEndedDate', true, 'from') },
            React.createElement(DateInput, { allowNull: true, style: { marginBottom: '0' }, value: (caseFilter.caseEndedDate &&
                    caseFilter.caseEndedDate.from &&
                    moment(caseFilter.caseEndedDate.from)) ||
                    undefined, onChange: (e) => caseFilterStore.updateFilter({
                    caseEndedDate: {
                        ...caseFilter.caseEndedDate,
                        from: e.format(),
                    },
                }), placeholder: lang.caseFilter.caseEndedAfterPlaceholder })),
        React.createElement(FilterOption, { active: !!(caseFilter.caseEndedDate && caseFilter.caseEndedDate.to), header: lang.caseFilter.caseEndedBefore, onDeactivate: () => caseFilterStore.clearFilter('caseEndedDate', true, 'to') },
            React.createElement(DateInput, { allowNull: true, style: { marginBottom: '0' }, value: (caseFilter.caseEndedDate &&
                    caseFilter.caseEndedDate.to &&
                    moment(caseFilter.caseEndedDate.to)) ||
                    undefined, onChange: (e) => caseFilterStore.updateFilter({
                    caseEndedDate: {
                        ...caseFilter.caseEndedDate,
                        to: e.format(),
                    },
                }), placeholder: lang.caseFilter.caseEndedBeforePlaceholder })),
        React.createElement(FilterOption, { active: !!caseFilter.caseSeqIds, header: lang.caseFilter.caseSeqIds, onDeactivate: () => {
                caseFilterStore.clearFilter('caseSeqIds');
                caseFilterStore.clearFilter('exceptCaseSeqIds');
                setCaseSeqIdValue('');
            } },
            React.createElement("p", null, lang.caseFilter.caseSeqIdsDescription),
            React.createElement(Textarea, { value: caseSeqIdValue, style: { height: '150px' }, onChange: (e) => {
                    const val = e.target.value;
                    setCaseSeqIdValue(val);
                    if (tid) {
                        clearTimeout(tid);
                    }
                    tid = setTimeout(() => {
                        const ids = val
                            .split(/[ ,;\n]+/)
                            .map((id) => id.trim())
                            .filter((id) => id && !isNaN(parseInt(id)))
                            .map((id) => parseInt(id));
                        caseFilterStore.updateFilter({
                            caseSeqIds: ids.length ? ids : undefined,
                        });
                    }, 500);
                }, placeholder: lang.caseFilter.caseSeqIds }),
            React.createElement(Checkbox, { checked: !!caseFilter.exceptCaseSeqIds, onChange: (e) => {
                    const val = e.target.checked;
                    caseFilterStore.updateFilter({
                        exceptCaseSeqIds: val || undefined,
                    });
                }, placeholder: lang.caseFilter.exceptCaseSeqIds }))));
};
export default CasesGroup;
//# sourceMappingURL=CasesGroup.js.map